import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import '../../App.css';
 

 const academics = props =>{
     return(
         <div className="desc full">
<VerticalTimeline>
<VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="2007 - 2015"
    iconStyle={{ background: "#bedbbb", color: 'black' }}
  >
    <h3 className="vertical-timeline-element-title">Matriculation</h3>
    <h4 className="vertical-timeline-element-subtitle">Girish Prasad Memorial College (ICSE)</h4>
    <p>
      Topper Of GPM College.
      Percentage : 94%
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="2015 - 2017"
    iconStyle={{ background: "#FFE5B4", color: 'black' }}
  >
    <h3 className="vertical-timeline-element-title">Intermediate</h3>
    <h4 className="vertical-timeline-element-subtitle">Gulab Rai Montessori (CBSE)</h4>
    <p>
      Among the TOP 10 School Toppers
      Percentage : 93%
      Course : PCM
    </p>
  </VerticalTimelineElement>
  <VerticalTimelineElement
    className="vertical-timeline-element--work"
    date="2018 - Present"
    iconStyle={{ background: '#8ac4d0', color: 'black' }}
  >
    <h3 className="vertical-timeline-element-title">Bachelor Of Technology Computer Science</h3>
    <h4 className="vertical-timeline-element-subtitle">National Institute Of Technology Patna</h4>
    <p>
      Branch Topper In First Year Of College
      CGPA : 9.28
      Courses : Operating System , OOPS , DBMS , DSA.
    </p>
  </VerticalTimelineElement>
</VerticalTimeline>
    </div>
     );
 }

 export default academics;